import React, { useState, useEffect } from "react";

export default function CALENDERtest(props) {
  const correctAnswers = [0, 3, 3, 1, 2, 2, 0, 1, 0, 2, 0, 1, 0, 1, 0, 1, 2, 3, 0, 2, 2, 0, 3, 1, 1];
  const que = {
    q1: {
      string: "1. Who was the founder of the Maratha Empire?",
      options: ["Shivaji Maharaj", "Rana Pratap", "Rani Laxmi Bai", "Peshwa Baji Rao"],
      ans: 0
    },
    q2: {
      string: "2. Which battle is known as the 'Third Battle of Panipat'?",
      options: ["Battle of Haldighati", "Battle of Plassey", "Battle of Buxar", "Battle of Panipat (1761)"],
      ans: 3
    },
    q3: {
      string: "3. In which ancient city was the archaeological site of Mohenjo-Daro discovered?",
      options: ["Harappa", "Lothal", "Kalibangan", "Mohenjo-Daro"],
      ans: 3
    },
    q4: {
      string: "4. Who was the prime minister of the Maratha Empire during the reign of Chhatrapati Shivaji Maharaj?",
      options: ["Baji Rao I", "Balaji Vishwanath", "Balaji Baji Rao", "Madhavrao I"],
      ans: 1
    },
    q5: {
      string: "5. Which Maratha ruler fought against the Mughals in the Battle of Haldighati?",
      options: ["Shivaji Maharaj", "Peshwa Baji Rao I", "Rana Pratap", "Rani Laxmi Bai"],
      ans: 2
    },
    q6: {
      string: "6. In which year did Shivaji Maharaj establish the Maratha kingdom?",
      options: ["1630", "1658", "1674", "1699"],
      ans: 2
    },
    q7: {
      string: "7. Who was the founder of the Peshwa dynasty in the Maratha Empire?",
      options: ["Balaji Vishwanath", "Baji Rao I", "Balaji Baji Rao", "Madhavrao I"],
      ans: 0
    },
    q8: {
      string: "8. Which Maratha leader fought against the British in the Anglo-Maratha Wars?",
      options: ["Shivaji Maharaj", "Peshwa Baji Rao II", "Rana Pratap", "Rani Laxmi Bai"],
      ans: 1
    },
    q9: {
      string: "9. What was the capital of the Maratha Empire during the Peshwa rule?",
      options: ["Pune", "Mumbai", "Delhi", "Agra"],
      ans: 0
    },
    q10: {
      string: "10. Who was the ruler of the Mewar kingdom known for his resistance against Mughal emperor Akbar?",
      options: ["Shivaji Maharaj", "Baji Rao I", "Rana Pratap", "Rani Laxmi Bai"],
      ans: 2
    },
    q11: {
      string: "11. In which year did the Battle of Panipat (1761) take place?",
      options: ["1761", "1757", "1764", "1771"],
      ans: 0
    },
    q12: {
      string: "12. Which Maratha leader defeated the Nizam of Hyderabad in the Battle of Rakshasbhuvan?",
      options: ["Shivaji Maharaj", "Peshwa Baji Rao I", "Rana Pratap", "Rani Laxmi Bai"],
      ans: 1
    },
    q13: {
      string: "13. What was the capital of the Maratha kingdom during the reign of Shivaji Maharaj?",
      options: ["Pune", "Raigad", "Mumbai", "Satara"],
      ans: 1
    },
    q14: {
      string: "14. Who was the commander-in-chief of the Maratha forces during the Third Battle of Panipat?",
      options: ["Peshwa Baji Rao I", "Sadashivrao Bhau", "Balaji Baji Rao", "Nana Saheb"],
      ans: 1
    },
    q15: {
      string: "15. Which Maratha ruler was known for his guerrilla warfare tactics against the Mughals?",
      options: ["Shivaji Maharaj", "Peshwa Baji Rao II", "Rana Pratap", "Rani Laxmi Bai"],
      ans: 0
    },
    q16: {
      string: "16. Which Maratha leader was also known as the 'Napoleon of India'?",
      options: ["Shivaji Maharaj", "Peshwa Baji Rao I", "Rana Pratap", "Rani Laxmi Bai"],
      ans: 1
    },
    q17: {
      string: "17. Who was the Maratha queen who fought against the British during the Indian Rebellion of 1857?",
      options: ["Peshwa Baji Rao II", "Sadashivrao Bhau", "Rana Pratap", "Rani Laxmi Bai"],
      ans: 3
    },
    q18: {
      string: "18. In which year did the Battle of Plassey take place?",
      options: ["1757", "1761", "1764", "1771"],
      ans: 0
    },
    q19: {
      string: "19. Who was the last Peshwa of the Maratha Empire?",
      options: ["Balaji Baji Rao", "Madhavrao I", "Peshwa Baji Rao II", "Nana Saheb"],
      ans: 2
    },
    q20: {
      string: "20. Which Maratha leader was involved in the Treaty of Purandar with the Mughals?",
      options: ["Shivaji Maharaj", "Peshwa Baji Rao I", "Rana Pratap", "Rani Laxmi Bai"],
      ans: 0
    },
    q21: {
      string: "21. Who was the Maratha king who escaped from Agra and established his rule again in Delhi?",
      options: ["Shivaji Maharaj", "Peshwa Baji Rao I", "Peshwa Baji Rao II", "Nana Saheb"],
      ans: 2
    },
    q22: {
      string: "22. Which Maratha leader fought against the Afghans in the Battle of Kondhana?",
      options: ["Shivaji Maharaj", "Peshwa Baji Rao I", "Rana Pratap", "Rani Laxmi Bai"],
      ans: 0
    },
    q23: {
      string: "23. Who was the ruler of Jhansi who played a significant role in the Indian Rebellion of 1857?",
      options: ["Peshwa Baji Rao II", "Sadashivrao Bhau", "Rana Pratap", "Rani Laxmi Bai"],
      ans: 3
    },
    q24: {
      string: "24. Which Maratha leader fought against the Nizam of Hyderabad in the Battle of Palkhed?",
      options: ["Shivaji Maharaj", "Peshwa Baji Rao I", "Rana Pratap", "Rani Laxmi Bai"],
      ans: 1
    },
    q25: {
      string: "25. Who was the Maratha ruler who signed the Treaty of Salbai with the British?",
      options: ["Peshwa Baji Rao II", "Madhavrao I", "Nana Saheb", "Balaji Baji Rao"],
      ans: 1
    }
  };

  const [ques, setques] = useState(que.q1.string);
  const [opts, setoptions] = useState(que.q1.options);
  const [userAns, setUserAns] = useState(null);
  const [userAnswers, setUserAnswers] = useState(Array(25).fill(null));
  const [score, setScore] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [timeLeft, setTimeLeft] = useState(900);
  let timer;
  useEffect(() => {
    timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          submitTest();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const renderNext = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion + 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const renderPrevious = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion - 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const handleAnswer = (answerIndex) => {
    setUserAns(answerIndex);
  };

  const submitTest = () => {
    setTimeLeft(0);

    setUserAnswers((prevUserAnswers) => {
      const newAnswers = [...prevUserAnswers];
      if (userAns !== null) {
        newAnswers[currentQuestion - 1] = userAns;
      }

      let newScore = 0;
      for (let i = 0; i < 25; i++) {
        if (correctAnswers[i] === newAnswers[i]) {
          newScore++;
        }
      }
      setScore(newScore);

      return newAnswers;
    });
  };

  return (
    <div className={props.mode}>
      <div className="heading">
        <h1>HISTORY <span>KNOWLEDGE</span> Test</h1>
      </div>
      <div className="codingInformation">
        <div className="time">
          <h1>Time Left: {formatTime(timeLeft)}</h1> 
        </div>
        <div className="score">
          <span>Your Score: {score}</span>
        </div>
        <div className="tracker">
          <span>Track Your Question</span>
        </div>
      </div>
      <div className="mobileTracker">
        <span>Track Your Question</span>
      </div>
      <div className="mainCodingContainer">
        <div className="questionContainer">
          <p>{ques}</p>
          <div className="options">
            {opts.map((option, index) => (
              <div key={index} className={`opt${index + 1}`}>
                <input
                  type="radio"
                  name={`que${currentQuestion}`}
                  onChange={() => handleAnswer(index)}
                  checked={userAns === index}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>
          <div className="btns">
            <button className="btn" onClick={renderPrevious}>Previous</button>
            <button className="btn" onClick={renderNext}>Next</button>
            <button className="btn" id="submitTest" onClick={submitTest}>Submit Test</button>
          </div>
          <div className="mobsub">
          <button className="btn" id="mobileSubmitTest" onClick={submitTest}>Submit Test</button>
          </div>
        </div>
        <div className="questionTrackerContainer">
          <div className="qtboxInformation">
            <div></div>
            <strong>Current</strong>
            <div></div>
            <strong id="solved">Solved</strong>
            <div></div>
            <strong id="unsolved">Unsolved</strong>
          </div>
          <div className="questionTracker">
            {[...Array(25)].map((_, i) => (
              <div
                key={i}
                className={`question ${currentQuestion === i + 1 ? 'current-question' : ''} ${userAnswers[i] !== null ? 'solved' : 'unsolved'}`}
              >
                {i + 1}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
